import {TasksI18n} from '@/locales/base.message.locales';

export const tasks: TasksI18n = {
  buttons: {
    abort: 'Abort Task',
    accept: 'Accept Task'
  },
  labels: {
    users: 'User | Users',
    already_in: 'Already in this task'
  },
  messages: {
    abort_fail: 'Fail to abort this task',
    abort_success: 'Task Aborted',
    accept_fail: 'Fail to accept this task',
    accept_success: 'Task Accepted'
  },
};
